var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_456_2787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.92999 22.53C5.07999 22.53 3.32999 21.81 2.01999 20.5C-0.690012 17.79 -0.690012 13.39 2.01999 10.69L10.69 2.02C11.08 1.63 11.7 1.63 12.09 2.02C12.48 2.41 12.48 3.03 12.09 3.42L3.42999 12.08C1.49999 14.01 1.49999 17.16 3.42999 19.09C4.36999 20.03 5.60999 20.54 6.93999 20.54C8.26999 20.54 9.50999 20.02 10.45 19.09L21.09 8.45C21.7 7.84 22.03 7.04 22.03 6.18C22.03 5.32 21.7 4.52 21.09 3.91C20.48 3.3 19.68 2.97 18.82 2.97C17.96 2.97 17.16 3.3 16.55 3.91L5.89999 14.56C5.61999 14.84 5.46999 15.2 5.46999 15.59C5.46999 15.98 5.61999 16.35 5.89999 16.62C6.46999 17.19 7.39999 17.19 7.95999 16.62L16.62 7.96C17.01 7.57 17.63 7.57 18.02 7.96C18.41 8.35 18.41 8.97 18.02 9.36L9.35999 18.02C8.01999 19.36 5.83999 19.36 4.49999 18.02C3.84999 17.37 3.48999 16.51 3.48999 15.59C3.48999 14.67 3.84999 13.81 4.49999 13.16L15.14 2.52C16.12 1.54 17.42 1 18.81 1C20.2 1 21.5 1.54 22.48 2.52C23.46 3.5 24 4.8 24 6.19C24 7.58 23.46 8.88 22.48 9.86L11.84 20.5C10.53 21.81 8.78999 22.53 6.92999 22.53Z",
    fill: "#0F0F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_456_2787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeading);
export default __webpack_public_path__ + "static/media/Leading.132c3648.svg";
export { ForwardRef as ReactComponent };